
























import { Vue, Component, Prop } from "vue-property-decorator";
import { IEventable } from '@/loader';
import EventableEdit from "./EventableEdit.vue";

@Component({
	components: {
		EventableEdit,
	},
})
export default class EventableModal extends Vue {
	@Prop({ type: Object, default: null })
	public item!: IEventable;

	@Prop({ type: String, default: "Changement de statut" })
	public title!: string;

	@Prop({ type: String, default: "eventable_modal" })
	public id!: string;

	@Prop({ type: String, default: "Continuer" })
	public okTitle!: string;

	@Prop({ type: String, default: "Annuler" })
	public cancelTitle!: string;

	@Prop({ type: String, default: "success" })
	public okVariant!: string;

	@Prop({ type: String, default: "outline-secondary" })
	public cancelVariant!: string;

	@Prop({ type: Boolean, default: false })
	public hideDescription!: boolean;

	@Prop({ type: Boolean, default: false })
	public hideDate!: boolean;

	@Prop({ type: Boolean, default: false })
	public centered!: boolean;
}
